%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 85449c2ea301fc54091646f096d9e4dc, type: 3}
  m_Name: PoisonBossFly
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 0}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  playOnCast: []
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 8300000, guid: 7994f284bb25ca64fa21bb890b0e5e98, type: 3}
  beforeChannelSoundDelay: 0
  beforeChannelSoundVolume: 1
  soundAfterChannel: {fileID: 0}
  afterChannelSoundDelay: 0
  afterChannelSoundVolume: 1
  animation: 16
  animationVariation: 7
  castDelay: 0
  animationSpeed: 1
  animationDuration: 1
  skipCooldownOnChannel: 0
  spellName: Toxic Rainfall
  description: Fly up and rain down toxic missiles.
  icon: {fileID: 2800000, guid: fab145eb7120b764e9a9e629c4f93e5b, type: 3}
  usableBy: 1a000000
  cooldown: 60
  castTime: 0
  isCastInterruptible: 0
  channelTime: 0
  isOnGlobalCooldown: 1
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 1
  useKeyboardForFacing: 0
  spellType: {fileID: 11400000, guid: 80cddad32b4f07e4bbf640afdccb32f4, type: 2}
  spellKey: 100099
  alwaysCastableSpell: 0
  luaScript: {fileID: 4900000, guid: 59602f092113ef54eac40ff68add77d2, type: 3}
